'use strict';

export const byAction = (state, getters) => actionID => {
	return getters.find({
		query: {
			action: actionID,
			$sort: { date: 1 },
		}
	}).data;
};

//=================================================================================================================

export const hasUserFeedbackedAction = (state, getters) => (actionID, userID) => {
	const request = getters.find({
		query: { action: actionID, author: userID, $limit: 0 },
		paginate: true,
	});

	return !!request.total;
};

//=================================================================================================================

export const editDialogVisible = state => state.editDialog.visible;

//=================================================================================================================

export const editDialogCopy = state => state.editDialog.copy;